import auth from "@/auth/index"
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/crossChain',
        name: 'crossChain',
        component: resolve => require(['@/views/crossChain/index'], resolve),
        meta: {
          title: '跨链服务',
          breadLevel: 0,
          icon: 'icon-cross-chain',
          auth: auth.crosschain
        }
      },
      {
        path: '/crossChain/crossChainRecord',
        name: 'crossChainRecord',
        component: resolve => require(['@/views/crossChain/crossChainRecord'], resolve),
        meta: {
          title: '跨链交易记录',
          breadLevel: 1,
          icon: 'icon-cross-chain',
        }
      }
    ]
  }
]
export default routes
